// Список банков России
export const BANKS = [
    "Сбербанк",
    "Т-Банк",
    "Альфа-Банк",
    "ВТБ",
    "Газпромбанк",
    "Совкомбанк",
    "Россельхозбанк",
    "Райффайзен Банк",
    "АБ РОССИЯ",
    "Абсолют Банк",
    "Авангард",
    "Автоторгбанк",
    "Авто Финанс Банк",
    "АГРОПРОМ КРЕДИТ",
    "Азиатско-Тихоокеанский Банк",
    "Ак Барс Банк",
    "АКБ Держава",
    "АКБ ЕВРОФИНАНС МОСНАРБАНК",
    "АКБ Приморье",
    "АКБ СЛАВИЯ",
    "АКБ Тендер Банк",
    "АКБ ЦентроКредит",
    "АКИБАНК",
    "Алеф-Банк",
    "Алмазэргиэнбанк",
    "АО \"ПЕРВОУРАЛЬСКБАНК\"",
    "Аресбанк",
    "Банк Аверс",
    "Банк Агророс",
    "Банк Акцепт",
    "Банк Александровский",
    "Банк ББР",
    "Банк ВБРР",
    "Банк Венец",
    "Банк Вологжанин",
    "Банк ДОМ.РФ",
    "Банк Заречье",
    "Банк Зенит",
    "Банк Интеза",
    "Банк ИПБ",
    "Банк ИТУРУП",
    "Банк Йошкар-Ола",
    "Банк Казани",
    "Банк Кремлевский",
    "Банк Кузнецкий",
    "Банк МБА-МОСКВА",
    "Банк Мир Привилегий",
    "БАНК МОСКВА-СИТИ",
    "Банк НОВИКОМ (НОВИКОМБАНК)",
    "Банк Объединенный капитал",
    "Банк Оранжевый",
    "БАНК ОРЕНБУРГ",
    "Банк ПСКБ",
    "Банк Развитие-Столица",
    "Банк Раунд",
    "Банк РСИ",
    "Банк Русский Стандарт",
    "Банк Санкт-Петербург",
    "Банк Саратов",
    "Банк Синара",
    "Банк Снежинский",
    "БАНК УРАЛСИБ",
    "Банк Финсервис",
    "Банк ЧБРР",
    "Белгородсоцбанк",
    "БЖФ Банк",
    "БКС Банк",
    "Бланк банк",
    "Братский АНКБ",
    "БыстроБанк",
    "Вайлдберриз Банк",
    "ВЛАДБИЗНЕСБАНК",
    "ВНЕШФИНБАНК",
    "ВУЗ банк",
    "Газтрансбанк",
    "Газэнергобанк",
    "ГЕНБАНК",
    "ГОРБАНК",
    "ГУТА-БАНК",
    "Дальневосточный банк",
    "Датабанк",
    "Долинск",
    "Драйв Клик Банк",
    "Единая касса",
    "Енисейский Объединенный банк",
    "Земский банк",
    "Золотая Корона (РНКО Платежный центр)",
    "ИК Банк",
    "Инбанк",
    "Ингосстрах Банк",
    "ИШБАНК",
    "КБ Байкалкредобанк",
    "КБ ИС Банк",
    "КБ Новый Век",
    "КБ Пойдем!",
    "КБ РостФинанс",
    "КБ СОЛИДАРНОСТЬ",
    "КБ Стройлесбанк",
    "КБ Хлынов",
    "КБ ЮНИСТРИМ",
    "Контур.Банк",
    "КОШЕЛЕВ-БАНК",
    "Кредит Европа Банк (Россия)",
    "Кредит Урал Банк",
    "Крокус-Банк",
    "Кубань Кредит",
    "Кубаньторгбанк",
    "Кузнецкбизнесбанк",
    "Ланта-Банк",
    "Левобережный",
    "ЛОКО-Банк",
    "МЕЖДУНАРОДНЫЙ ФИНАНСОВЫЙ КЛУБ",
    "Металлинвестбанк",
    "МЕТКОМБАНК",
    "Мир Бизнес Банк",
    "МКБ",
    "Модульбанк",
    "МОНЕТА",
    "МОРСКОЙ БАНК",
    "МОСКОМБАНК",
    "Москоммерцбанк",
    "МС Банк Рус",
    "МТС-Банк",
    "Нацинвестпромбанк",
    "Национальный стандарт",
    "НБД-Банк",
    "НИКО-БАНК",
    "НК Банк",
    "НКО МОБИ.Деньги",
    "НКО Мобильная карта",
    "Новобанк",
    "НОКССБАНК",
    "Норвик Банк",
    "НРБанк",
    "НС Банк",
    "Озон Банк (Ozon)",
    "ООО \"ЖИВАГО БАНК\"",
    "Открытие",
    "ОТП Банк",
    "Первый Дортрансбанк",
    "Первый Инвестиционный Банк",
    "Почта Банк",
    "Примсоцбанк",
    "Прио-Внешторгбанк",
    "ПроБанк",
    "Промсвязьбанк",
    "ПромТрансБанк",
    "Реалист Банк",
    "Ренессанс Банк (Ренессанс Кредит)",
    "РЕСО Кредит",
    "РНКБ Банк",
    "РНКО Платежный конструктор",
    "Рокетбанк",
    "Росбанк",
    "РосДорБанк",
    "Роял Кредит Банк",
    "РУСНАРБАНК",
    "Русьуниверсалбанк",
    "СДМ-Банк",
    "Севергазбанк",
    "Северный Народный Банк",
    "Сибсоцбанк",
    "СИНКО-БАНК",
    "СНГБ",
    "Солид Банк",
    "СОЦИУМ-БАНК",
    "Ставропольпромстройбанк",
    "Таврический Банк",
    "ТАТСОЦБАНК",
    "Тимер Банк",
    "Тойота Банк",
    "Тольяттихимбанк",
    "Томскпромстройбанк",
    "Точка Банк",
    "Транскапиталбанк",
    "Трансстройбанк",
    "УБРиР",
    "Углеметбанк",
    "УРАЛПРОМБАНК",
    "Урал ФД",
    "Уралфинанс",
    "ФИНАМ",
    "ФИНСТАР БАНК",
    "ФОРА-БАНК",
    "Форштадт",
    "Хайс",
    "Хакасский муниципальный банк",
    "Хоум Кредит Банк (Хоум Банк)",
    "Центр-инвест",
    "Цифра банк",
    "ЦМРБанк",
    "ЧЕЛИНДБАНК",
    "ЧЕЛЯБИНВЕСТБАНК",
    "Экономбанк",
    "ЭКСИ-Банк (АО)",
    "Экспобанк",
    "Элита",
    "Элплат",
    "Энергобанк",
    "Энерготрансбанк",
    "Эс-Би-Ай Банк",
    "ЮГ-Инвестбанк",
    "Юникредит Банк",
    "Яндекс Банк",
    "Яринтербанк",
    "VK Pay - ВК Платёжные решения"
] as const;
